import Vue from 'vue'
import App from './App.vue'
import DesignSystem from 'mot-design-system'
import VueAnimated from '@rozhkovv/vue-animated'
import "@/utils/webFontLoader"
import 'mot-design-system/dist/system/system.css'

Vue.use(DesignSystem)
Vue.use(VueAnimated)
Vue.config.productionTip = false
new Vue({
  render: h => h(App),
}).$mount('#app')
